export function isPopulateOptionSetMeta(
  value: CustomFunctionMeta,
): value is PopulateOptionSetMeta {
  return 'staticOptions' in value && 'dynamicOptions' in value
}

export function isPopulateValueMeta(
  value: CustomFunctionMeta,
): value is PopulateValueMeta {
  return 'sourceElements' in value && 'condition' in value
}

export function isConditionallyReadOnlyMeta(
  value: CustomFunctionMeta,
): value is ConditionallyReadOnlyMeta {
  return 'condition' in value
}
